import keysToConstants from 'js/lib/keysToConstants';

import type { PrimaryFilterType } from 'bundles/enterprise-admin-user-filters/types';
import { AttributeSelections } from 'bundles/enterprise-admin-users/types';

export const SYNCHRONOUS_IMPORT = 'synchronousImport';
export const ASYNCHRONOUS_IMPORT = 'asynchronousImport';

const EnterpriseTrafficLightConstants = {
  CRITICAL: 'CRITICAL',
  WARNING: 'WARNING',
  NORMAL: 'NORMAL',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  INACTIVE: 'INACTIVE',
  AT_RISK: 'AT_RISK',
};

export const { CRITICAL, WARNING, NORMAL, ACTIVE, COMPLETED, INACTIVE, AT_RISK } = EnterpriseTrafficLightConstants;

export const CHECKED_BACKGROUND_COLOR = 'rgba(131,169,223,0.1)';

export const TABLE_HEIGHT = 400;

export const IMPORT_LEARNERS_STEPS = keysToConstants([
  'UPLOAD',
  'CHOOSE_CONTRACT',
  'CHOOSE_PROGRAM',
  'PREVIEW',
  'CONFIRM',
  'RESULTS',
]);

export const CREATE_LEARNER_STEPS = keysToConstants(['INPUT_DETAILS', 'CHOOSE_PROGRAM', 'CHOOSE_CONTRACT', 'PREVIEW']);

const { learner, joinedAt, invitedAt, programNames, numEnrollments, numCompletions, deletedAt, isSoftDeleted, status } =
  AttributeSelections;

export const DEFAULT_INVITATIONS_COLUMNS = [learner, invitedAt, programNames, numEnrollments, numCompletions];
export const DEFAULT_MEMBERS_COLUMNS = [learner, joinedAt, programNames, numEnrollments, numCompletions];
export const DEFAULT_DELETED_MEMBERS_COLUMNS = [learner, joinedAt, deletedAt, isSoftDeleted];
export const DEFAULT_MEMBERS_PROGRAM_SCOPE_COLUMNS = [learner, joinedAt, status, numEnrollments, numCompletions];
export const DEFAULT_INVITATIONS_PROGRAM_SCOPE_COLUMNS = [learner, invitedAt, numEnrollments, numCompletions];

export const getDefaultColumns = (isProgramScope: boolean, primaryFilter?: PrimaryFilterType): AttributeSelections[] =>
  primaryFilter
    ? (
        {
          INVITED: isProgramScope ? DEFAULT_INVITATIONS_PROGRAM_SCOPE_COLUMNS : DEFAULT_INVITATIONS_COLUMNS,
          REMOVED_MEMBER: DEFAULT_DELETED_MEMBERS_COLUMNS,
          MEMBER: isProgramScope ? DEFAULT_MEMBERS_PROGRAM_SCOPE_COLUMNS : DEFAULT_MEMBERS_COLUMNS,
          MULTI_TYPE_FILTER: isProgramScope ? DEFAULT_MEMBERS_PROGRAM_SCOPE_COLUMNS : DEFAULT_MEMBERS_COLUMNS,
        } as const
      )[primaryFilter]
    : [];
